var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.25 12.19 9.03 9.97a.75.75 0 0 0-1.06 1.06l3.146 3.147a1.25 1.25 0 0 0 1.768 0l3.146-3.147a.75.75 0 1 0-1.06-1.06l-2.22 2.22V5.5a.75.75 0 0 0-1.5 0v6.69ZM4.75 17A2.25 2.25 0 0 0 7 19.25h10A2.25 2.25 0 0 0 19.25 17v-1.5a.75.75 0 0 0-1.5 0V17a.75.75 0 0 1-.75.75H7a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 0-1.5 0V17Z",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;